import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/portal");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] pt-32 pb-24 px-5 flex items-start justify-center" data-testid="login-page">
      <Seo title="Client Login" path="/login" />
      <div className="w-full max-w-md border border-white/10 bg-ink-surface p-8 sm:p-10">
        <img src="/arsenal-artists-logo.png" alt="Arsenal Artists emblem" className="h-14 w-14 object-contain" />
        <h1 className="mt-5 font-display text-2xl font-black tracking-tight">Client Portal</h1>
        <p className="mt-1 text-sm text-slate-500">Track projects, review work, download files.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          {error && <p className="border border-arsenal/50 bg-arsenal/10 px-4 py-3 text-sm text-arsenal-bright" data-testid="login-error">{error}</p>}
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Email</span>
            <input type="email" required data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="aa-input" autoComplete="email" />
          </label>
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Password</span>
            <input type="password" required data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="aa-input" autoComplete="current-password" />
          </label>
          <button type="submit" disabled={busy} data-testid="login-submit" className="clip-btn w-full bg-arsenal hover:bg-arsenal-bright disabled:opacity-50 text-white font-display font-bold tracking-widest text-sm py-3.5 transition-colors">
            {busy ? "SIGNING IN…" : "SIGN IN"}
          </button>
        </form>
        <p className="mt-6 text-sm text-slate-500">
          New client?{" "}
          <Link to="/register" data-testid="login-register-link" className="text-arsenal hover:text-arsenal-bright">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
